export const selectAllowMaybeRSVPs = ({guestOptions}) => guestOptions.allowMaybeRSVPs;
export const selectRSVPDeadline = ({guestOptions}) => guestOptions?.rsvpDeadline;
export const selectRsvpDeadlineIsStrict = ({guestOptions}) => guestOptions?.rsvpDeadlineIsStrict;
export const selectAllowBringPeople = ({guestOptions}) => guestOptions.allowBringPeople;
export const selectAllowKids = ({guestOptions}) => guestOptions.allowKids;
export const selectLimitPerGuest = ({guestOptions}) => guestOptions.limitPerGuest;
export const selectMaxGuestList = ({guestOptions}) => guestOptions.maxGuestList;
export const selectShowMaxGuest = ({guestOptions}) => guestOptions.showMaxGuest;
export const selectHideGuestlist = ({guestOptions}) => guestOptions.hideGuestlist;
